import { createApp, nextTick, toRaw } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
// 引入阿里图标库
import '@/assets/icon/iconfont.css'
import '@/assets/styles/element-style.css'

// 微前端解决子应用引用静态资源出错问题
import './public-path.js'

// 引入国际化
import i18n from '@/i18n'

// 全局基础样式
import '@/assets/styles/base.css'
import '@/assets/styles/normalize.css'
// 常用的class
import '@/assets/styles/common.less'
import '@/assets/styles/variable.less'
import '@/assets/styles/components.less'
// 注册全局组件
import components from '@/components/index'






// 引入pinia
// import pinia from '@/store'
import { createPinia, PiniaPlugin, PiniaPluginContext } from 'pinia'
import piniaPlugin from './store/piniaPlugin'
import { useCommon } from '@/store/useCommon';
const app = createApp(App)

const pinia = createPinia();
pinia.use(piniaPlugin({
  key: "pinia", // 这是给缓存到本地时，加一个特殊的前缀，以免造成污染到其他缓存数据
  needKeepIds: [], // 对于特定store进行持久化，空或者不传，则对所有的store进行缓存到本地
}))
app.use(pinia)

// vue virtual scroller
// import "vue-virtual-scroller/dist/vue-virtual-scroller.css" // 引入它的 css
// import VueVirtualScroller from "vue-virtual-scroller" // 引入它

const storeCommon = useCommon()
// 注册全局指令
import directives from '@/directive/index.js'

app.use(router).use(ElementPlus, { size: 'default' }).use(i18n).use(components).use(directives)
.mount('#app');

// (window as any)?.microApp.dispatch({
//   message: '子应用发送'
// })

(window as any)?.microApp?.addDataListener((data: any) => {
  if (data.lang) {
    storeCommon.changeLang(data.lang)
  }
  if (data.token) {
    storeCommon.addToken(data.token)
  }
  if (data.user) {
    storeCommon.addUserData({ ...data.user })
  }
  if (data.cacheData) {
    storeCommon.setCacheData({ ...data.cacheData })
  }
}, true)

// 监听卸载操作 (卸载子应用)
window.addEventListener('unmount', function () {
  app.unmount()
})

